/* ============
 * Warehouse Transformer
 * ============
 */

import Transformer from './transformer';

export default class UnitOfMeasureTransformer extends Transformer {

  static fetch(unitOfMeasure) {
    return {
      id: unitOfMeasure.id,
      name: unitOfMeasure.name,
      code: unitOfMeasure.code,
    };
  }

  static send(unitOfMeasure) {
    return {
      id: unitOfMeasure.id,
      name: unitOfMeasure.name,
      code: unitOfMeasure.code,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/unitOfMeasure.js